<canvas class="border border-dark" #maze_canvas width="400px" height="400px"></canvas>